import { MenuItem } from './sidebar.component';

export const menuItems: MenuItem[] = [
  {
    name: 'Inicio',
    icon: 'house',
    route: '/home',
  },
  {
    name: 'Casos',
    icon: 'wrench',
    route: '/home/servicescases',
  },
  {
    name: 'Operaciones',
    icon: 'briefcase',
    subItems: [
      {
        name: 'Reclamos',
        icon: 'card-text',
        route: '/home/claims',
      },
      {
        name: 'Diagnósticos',
        icon: 'card-checklist',
        route: '/home/diagnosis',
      },
      {
        name: 'Cotizaciones',
        icon: 'file-earmark-break',
        route: '/home/quotes',
      },
      {
        name: 'Citas',
        icon: 'calendar-check',
        route: '/home/appointments',
      },
      {
        name: 'Recepciones',
        icon: 'car-front',
        route: '/home/receptions',
      },
      {
        name: 'Órdenes de trabajo',
        icon: 'briefcase',
        route: '/home/workorders',
      },
    ],
  },
  {
    name: 'Registros',
    icon: 'folder',
    subItems: [
      {
        name: 'Clientes',
        icon: 'people',
        route: '/home/clients',
      },
      {
        name: 'Vehículos',
        icon: 'car-front',
        route: '/home/vehicle',
      },
    ],
  },

  {
    name: 'Inventario',
    icon: 'save',
    subItems: [
      {
        name: 'Maestro de artículos',
        icon: 'list-check',
        route: '/home/items',
      },
      {
        name: 'Ordenes de compra',
        icon: 'cart-check',
        route: '/home/purchaseorders',
      },
      {
        name: 'Conduces',
        icon: 'list-ol',
        route: '/home/deliverynotes',
      },
      {
        name: 'Inv. de Piezas',
        icon: 'tools',
        route: '/home/parts',
      },
      {
        name: 'Inv. de Insumos',
        icon: 'clipboard-check',
        route: '/home/purchase-inventory',
      },
      {
        name: 'Devoluciones',
        icon: 'arrow-return-left',
        route: '/home/returns',
      },
    ],
  },
  {
    name: 'Reportes',
    icon: 'bar-chart',
    subItems: [
      {
        name: 'Estadisticas',
        icon: 'graph-up',
        route: '/home/dashboard',
      },
      {
        name: 'Reportes',
        icon: 'bar-chart',
        route: '/home/reports',
      },
    ],
  },
  {
    name: 'Administrador',
    icon: 'person-gear',
    subItems: [
      {
        name: 'Usuarios',
        icon: 'person',
        route: '/home/users',
      },
      {
        name: 'Aseguradoras',
        icon: 'shield',
        route: '/home/insurance',
      },
      {
        name: 'Proveedores',
        icon: 'truck',
        route: '/home/suppliers',
      },
      {
        name: 'Roles',
        icon: 'key',
        route: '/home/roles',
      },
      {
        name: 'Compañía',
        icon: 'building',
        route: '/home/company',
      },
    ],
  },
];
